// @ts-strict-ignore
import React from 'react';
import type { Control, FieldErrors } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import {
  Box,
  TextArea,
} from '@usealloy/component-library';

export const CSV_FORMAT_ERROR_LINE_BREAK = 'Values must not contain line breaks';
export const CSV_FORMAT_ERROR_COMMA_BEGIN = 'Values must not begin with a comma';
export const CSV_FORMAT_ERROR_COMMA_MULT = 'Values must not contain consecutive commas';

export type ValidValuesFieldProps = {
  control: Control<any>;
  errors: FieldErrors;
  disabled?: boolean;
};

const ValidValuesField = ({
  control, errors, disabled = false,
}: ValidValuesFieldProps) => {
  const {
    validValues: validValuesError,
  } = errors;

  return (
    <Box direction="column">
      <Controller
        control={control}
        name="validValues"
        defaultValue=""
        rules={{
          validate: value => {
            if (value.match(/(\r\n|\r|\n)/)) {
              return CSV_FORMAT_ERROR_LINE_BREAK;
            }
            if (value.match(/^,/)) {
              return CSV_FORMAT_ERROR_COMMA_BEGIN;
            }
            if (value.match(/,{2,}/)) {
              return CSV_FORMAT_ERROR_COMMA_MULT;
            }
            return null;
          },
          deps: ['defaultValue'],
        }}
        render={({ field: { ref: fieldRef, value, ...field } }) => (
          <TextArea
            {...field}
            value={value ?? ''}
            ref={fieldRef}
            label="Accepted Values"
            placeholder="type or copy/paste comma-separated strings"
            error={validValuesError?.message as unknown as React.ReactNode}
            disabled={disabled}
          />
        )}
      />
    </Box>
  );
};

export default ValidValuesField;
